import moment from 'moment';
import styles from './index.module.sass';
import main from 'images/oil-pricing/main.png';
import stateUp from 'images/oil-pricing/state_up.png';
import stateDown from 'images/oil-pricing/state_down.png';
import stateStable from 'images/oil-pricing/state_stable.png';
import pba from 'images/icon_powered-by-Autopass.svg';
import { useEffect, useState } from 'react';
import repository from 'service/repository';
import amplitudeService from 'service/amplitude';
moment.locale('en', {
  week: {
    dow: 1,
  },
});

const GasPrice = () => {
  const [pricing, setPricing] = useState(null);
  const startOfCurrentWeek = moment().startOf('week');
  const endOfCurrentWeek = moment().endOf('week');
  const startOfNextWeek = moment()
    .startOf('week')
    .add(1, 'week');
  const endOfNextWeek = moment()
    .endOf('week')
    .add(1, 'week');

  const predictPricingText = value => {
    if (value === '+0.0') {
      return '不變';
    }
    if (value.includes('+')) {
      return `漲 ${value.replace('+', '')}`;
    } else if (value.includes('-')) {
      return `降 ${value.replace('-', '')}`;
    }
  };

  const predictPricingImage = value => {
    if (value === '+0.0') {
      return stateStable;
    }
    if (value.includes('+')) {
      return stateUp;
    } else if (value.includes('-')) {
      return stateDown;
    }
  };

  const currentPricingText = value => {
    return parseFloat(value).toFixed(1);
  };

  const dateFormatter = time => time.format('YYYY.MM.DD');

  useEffect(() => {
    amplitudeService.track('油價公告_pageview');
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const [err, data] = await repository.fetchOilPricing();
      console.log(data);
      if (err) {
        console.log(err);
      }

      console.log(data);
      setPricing(data);
    };
    fetch();
  }, []);

  if (!pricing) {
    return <></>;
  }

  const predictPricing = [
    {
      name: '汽油',
      value: pricing?.predict.gas92,
    },
    {
      name: '柴油',
      value: pricing?.predict.diesel,
    },
  ];

  const currentPricing = [
    {
      name: '92汽',
      value: pricing?.current.gas92,
    },
    {
      name: '95汽',
      value: pricing?.current.gas95,
    },
    {
      name: '98汽',
      value: pricing?.current.gas98,
    },
    {
      name: '柴油',
      value: pricing?.current.diesel,
    },
  ];

  return (
    <div className={styles['gas-price']}>
      <img src={main} alt="main" />
      <div className={`${styles.block} ${styles.predict}`}>
        <h2>下週油價預測</h2>
        <p>
          {dateFormatter(startOfNextWeek)} - {dateFormatter(endOfNextWeek)}
        </p>
        <p>實際油價依中油週日公布</p>
        <div className={styles.pricing}>
          {predictPricing.map(price => {
            const imageSrc = predictPricingImage(price.value);
            const text = predictPricingText(price.value);
            return (
              <div>
                <img src={imageSrc} alt="state" />
                <h3>{price.name}</h3>
                <p>{text}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className={`${styles.block} ${styles.current}`}>
        <h2>本週油價</h2>
        <p>
          {dateFormatter(startOfCurrentWeek)} - {dateFormatter(endOfCurrentWeek)}
        </p>
        <div className={styles.pricing}>
          {currentPricing.map(price => {
            const text = currentPricingText(price.value);
            return (
              <div>
                <h3>{price.name}</h3>
                <p>{text}</p>
              </div>
            );
          })}
        </div>
      </div>
      <img src={pba} alt="pba" className={styles.pba} />
    </div>
  );
};

export default GasPrice;
